export default __webpack_public_path__ + "static/media/4.5ad0df9e.png";